var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',{staticClass:"divider",style:([{width: _vm.width ? _vm.width : '100%'}]),attrs:{"role":"presentation"}})}
var staticRenderFns = []

export { render, staticRenderFns }